import { render } from "./ConfirmDeleteRowCategory.vue?vue&type=template&id=6dd8575d&scoped=true"
import script from "./ConfirmDeleteRowCategory.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteRowCategory.vue?vue&type=script&lang=js"

import "./ConfirmDeleteRowCategory.vue?vue&type=style&index=0&id=6dd8575d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd8575d"]])

export default __exports__